import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const WindowEditLazy = loadable(() => import(/* webpackChunkName: "WindowEdit" */ './WindowEditSuspense'));

export const WindowEditAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <WindowEditLazy />
    </DelayedSuspense>
);
